import {IMrt_RowActions} from "./components/grid/IMrt_RowActions";
import {IMrt_grid_prop} from "./components/grid/IMrt_grid_prop";
import IseMrtGridClient from "./components/grid/MRT_Grid_Client";
import IseMrtGridVirtual from "./components/grid/MRT_Grid_Virtual";
import IseMrtGridServer from "./components/grid/MRT_Grid_Server";
import IseDateTimePicker from "./components/jalaliDatePicker/JalaliDatePicker";
import IseTextFiled from './components/textField/textField';
import {IseCaptcha,generateCaptcha,validateCaptcha} from './components/captcha/IseCaptcha';
import IseButton from './components/button/button';
import { MRT_ColumnDef } from "material-react-table";
import IsePlaque from "./components/pelak/isePelak";
import { checkCodeMeli } from "./components/nationalCode";


/*
const IseLib = () => {
  return {
    Ise_MrtGridClient: Ise_MrtGridClient,
    Ise_MrtGridVirtual: Ise_MrtGridVirtual,
    Ise_MrtGridServer: Ise_MrtGridServer,

    // you can add here other components that you want to export
  }
}
*/
export { IseMrtGridClient };
export { IseMrtGridVirtual };
export { IseMrtGridServer };
export { IseDateTimePicker };
export { IseTextFiled };
export { IseButton };
export { IsePlaque };
export { IseCaptcha,generateCaptcha,validateCaptcha };

const iseUtils = {checkCodeMeli};

//export default IseLib();
export { IMrt_RowActions, IMrt_grid_prop, MRT_ColumnDef, iseUtils };